/* RESPONSIBLE TEAM: team-knowledge-foundations */
import BaseSettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

export default class HelpcenterMain extends BaseSettingsRoute {
  beforeModel() {
    this.replaceWith('apps.app.settings.helpcenter.all');
  }
}
